export default __webpack_public_path__ + "static/media/category_10.0833b737.png";